const EventTypes = {
  CREATE_TING: 'createTing',
  TING_CREATED: 'tingCreated',
  UPDATE_TING: 'updateTing',
  TING_UPDATED: 'tingUpdated',
  UPDATE_PROGRAM: 'updateProgram',
  PROGRAM_UPDATED: 'programUpdated',
  PROGRAM_CREATED: 'programCreated'
}

export default EventTypes
